<template>
  <div
    class="flex items-center rounded-[5px] border border-blue h-[42px] w-[230px] sm:w-[295px]"
  >
    <input
      v-model="model"
      type="text"
      class="rounded-l p-[11px] w-full h-full outline-0 placeholder:font-normal text-[14px]"
      :placeholder="text"
      @input="handleInput"
    />
    <div
      class="h-full rounded-r border-l border-blue flex items-center justify-center bg-blue-60 p-[11px]"
    >
      <InlineSvg
        src="/assets/svg/icons/search.svg"
        class="w-[20px] h-[20px] text-white rotate-90"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import _ from 'lodash';
const emit = defineEmits(['update:modelValue', 'change']);

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
});

watch(
  () => props.modelValue,
  (newVal) => (model.value = newVal)
);

const model = ref(props.modelValue);
const handleInput = _.debounce(() => {
  emit('update:modelValue', model.value);
  emit('change');
}, 400);
</script>
